import { inject, Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { ServiceWorkerVersionControlService } from './service-worker-version-control.service';
import { UserContext } from '@irian-ro/util-user';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { FirebaseCloudMessagingService } from './firebase-cloud-messaging.service';

@Injectable()
export class ServiceWorkerMessageListener implements OnDestroy {

  private destroy$ = new Subject<boolean>();
  private firebaseCloudMessaging = inject(FirebaseCloudMessagingService);
  private serviceWorkerVersionControlService = inject(ServiceWorkerVersionControlService);
  private userContext = inject(UserContext);

  listenForServiceWorker(serviceWorkerEnabled: any): void {
    if ( serviceWorkerEnabled ) {
      this.serviceWorkerVersionControlService.listenToRouterEvents();
      this.userContext.getCurrentUser().pipe(
        distinctUntilChanged(),
        takeUntil(this.destroy$))
        .subscribe({
          next: (loggedInUser: any) => {
            if (loggedInUser.authType === "authUser") {
              this.firebaseCloudMessaging.requestPermissionAndSaveToken(loggedInUser);
              this.firebaseCloudMessaging.listenAndShowNotificationsForeground();
            }
          }
        });
    }

  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
